module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "titimg"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/74027_contt_pxi_t2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "conts"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Power"
    }
  }, [_c('i', [_vm._v("Note from Wendy: The Power of Impact")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_c('i', [_vm._v("Preface: Now is the Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_c('i', [_vm._v("Introduction: How to Get the Most From This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: The Multimillion-Dollar Mindset")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Focus On Impact Business Map")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Define Your Impact Action Formula")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Discover Your Unique Gift")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Design Your Ideal Lifestyle")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Determine Your Perfect Market")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Develop One-Of-A-Kind Products and Services")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Differentiate with Impact-Driven Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Deliver Your Impact and Move People to Action")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Diversify With Impact-Driven Collaboration")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Decide Which Advice is Best for You")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Dare to Go Bigger")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Action!")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: More "), _c('i', [_vm._v("Focus On Impact")]), _vm._v(" Success Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Backmatter",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lessons, Gifts and Gratitude")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Backmatter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("More Praise for Focus On Impact")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Backmatter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Meet Wendy")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Backmatter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Join Wendy Live and Online")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 81
// module chunks = 0